export default __webpack_public_path__ + "static/media/Poppins-ExtraBoldItalic.09f84f60.ttf";